var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-card",
    { attrs: { "max-width": "500" } },
    [
      _c("w-card-title", [_vm._v(_vm._s(_vm.title))]),
      _c(
        "w-scroll-view",
        { attrs: { tag: "w-card-content" } },
        [
          _c(
            "w-row",
            [
              _c("w-col", { attrs: { xs: "6" } }, [
                _vm._v(" " + _vm._s(_vm.$ct("common.example")) + ": "),
              ]),
              _c("w-col", { staticClass: "right", attrs: { xs: "6" } }, [
                _vm._v(" " + _vm._s(_vm.exampleNumber) + " "),
              ]),
            ],
            1
          ),
          _c(
            "w-row",
            [
              _c(
                "w-col",
                { attrs: { xs: "6" } },
                [
                  _c("w-input", {
                    attrs: { fancy: "", label: _vm.$ct("decimal-seperator") },
                    model: {
                      value: _vm.config.DecimalSeperator,
                      callback: function ($$v) {
                        _vm.$set(_vm.config, "DecimalSeperator", $$v)
                      },
                      expression: "config.DecimalSeperator",
                    },
                  }),
                ],
                1
              ),
              _c(
                "w-col",
                { attrs: { xs: "6" } },
                [
                  _c("w-input-number", {
                    attrs: {
                      decimals: 0,
                      min: 0,
                      max: 20,
                      fancy: "",
                      label: _vm.$ct("decimals"),
                    },
                    model: {
                      value: _vm.config.Decimals,
                      callback: function ($$v) {
                        _vm.$set(_vm.config, "Decimals", $$v)
                      },
                      expression: "config.Decimals",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "w-row",
            [
              _c(
                "w-col",
                { attrs: { xs: "6" } },
                [
                  _c("w-input", {
                    attrs: { fancy: "", label: _vm.$ct("thousands-seperator") },
                    model: {
                      value: _vm.config.ThousandsSeperator,
                      callback: function ($$v) {
                        _vm.$set(_vm.config, "ThousandsSeperator", $$v)
                      },
                      expression: "config.ThousandsSeperator",
                    },
                  }),
                ],
                1
              ),
              _c(
                "w-col",
                { attrs: { xs: "6" } },
                [
                  _c("w-input-number", {
                    attrs: {
                      decimals: 0,
                      min: 0,
                      max: 20,
                      fancy: "",
                      label: _vm.$ct("thousands-seperator-interval"),
                    },
                    model: {
                      value: _vm.config.ThousandsSeperatorInterval,
                      callback: function ($$v) {
                        _vm.$set(_vm.config, "ThousandsSeperatorInterval", $$v)
                      },
                      expression: "config.ThousandsSeperatorInterval",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "w-row",
            [
              _c(
                "w-col",
                { attrs: { xs: "12" } },
                [
                  _c("w-input-number", {
                    attrs: {
                      decimals: _vm.config.Decimals,
                      fancy: "",
                      label: _vm.$ct("default-value"),
                    },
                    model: {
                      value: _vm.config.DefaultValue,
                      callback: function ($$v) {
                        _vm.$set(_vm.config, "DefaultValue", $$v)
                      },
                      expression: "config.DefaultValue",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c("app-extra-field-base-options", {
            attrs: {
              value: _vm.config,
              "extra-fields-type": _vm.extraFieldsType,
            },
          }),
        ],
        1
      ),
      _c(
        "w-card-actions",
        [
          _c(
            "w-button",
            {
              staticClass: "cancel",
              attrs: { icon: "ban" },
              on: {
                click: function ($event) {
                  return _vm.close()
                },
              },
            },
            [_vm._v(_vm._s(_vm.$ct("common.cancel")))]
          ),
          _c("w-spacer"),
          _c(
            "w-button",
            {
              attrs: { icon: "check" },
              on: {
                click: function ($event) {
                  return _vm.confirm()
                },
              },
            },
            [_vm._v(_vm._s(_vm.$ct("common.confirm")))]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }